<template>
    <div class="hub-app-section small-sidebar other-apps-page"  v-if="appUrls">
        <side-bar v-if="!fullScreenUrls.includes($route.path)"
                  :class="{ 'width-80': appPage  }"
                  ref="sidebar"
        ></side-bar>
        <div :class="{ 'right-main-content' : !fullScreenUrls.includes($route.path),
                    'app-page': appPage,
                    'maxh-chat': $route.path == '/chat' }">
            <right-auth v-if="!fullScreenUrls.includes($route.path)"></right-auth>
            <router-view></router-view>
        </div>

    </div>
</template>

<script>
import ApiService from "../api/api.service";
import {mapActions} from 'vuex';
import SideBar from "../views/SideBar";
import RightAuth from "../views/RightAuth";
export default {
    name: 'App',
    data: () => {
        return {
            fullScreenUrls: [
                '/login',
                '/register',
                '/email/verify',
                '/forgot-password',
                '/password/reset',
                '/manage-account',
                '/subscription-plans'
            ],
            appUrls: [
                '/apps/dax',
                '/apps/m-code',
                '/apps/raw-code',
                '/apps/python-code',
                '/apps/r-code',
                '/apps/notepad',
                '/apps/colour-generator',
                '/apps/colour-generator/colours-fan',
                '/apps/colour-generator/image-to-colours',
                '/apps/colour-generator/colours-palette',
                '/apps/edna',
                '/apps/analytics-planner',
                '/apps/model-planner',
                '/apps/pipeline-planner',
                '/feature-locked',
                '/apps/power-bi-theme-generator',
                '/documents-limit'
            ],
            appPage: false,
        };
    },
    components: {
        RightAuth,
        SideBar
    },
    methods: {
        ...mapActions(['me']),
      appPages() {
          let appNames = [
              'Analytics Planner',
              'Planner task',
              'Priorities Matrix',
              'Priorities idea',
              'Data Model Planner',
              'Data Pipeline Planner',
              'Model Planner Task',
              'Pipeline Planner Task',
              'Project Share',
              'Require login',
              'Playlist',
              'PowerBiTheme'
          ];
          this.appPage = this.appUrls.includes(this.$route.path) || appNames.includes(this.$route.name);
      },
    //   userData() {
    //         ApiService.setHeader();
    //         ApiService.get('/api/user').then(({data}) => {
    //             this.user.name = data.name;
    //             this.user.email = data.email;
    //             this.user.photo = data.photo;
    //         }).catch(error => {
    //             throw new Error('failed to load user');
    //         });
    //     },
    },
    watch:{
        $route (to, from){
            // close sidebar on route change
            let sideBarSelector = document.querySelector('.left-sidebar');
            if(sideBarSelector)
                sideBarSelector.classList.remove('open-sidebar');

            // close sidebar on route change
            let selector = document.querySelector('.show');
            if(selector)
                selector.classList.remove('show');

            if(to != from) {
                this.appPages();
            }
        }
    },
    async mounted() {
        await this.me()
        this.appPages();

        let menuElements = document.querySelectorAll(".menu-toggle");
        // alert(menuElements[0]);
        for(let i = 0; i < menuElements.length;i++) {
            if(menuElements[i]) {
                menuElements[i].addEventListener('click', function () {
                    document.querySelector('.left-sidebar').classList.add('open-sidebar');
                    document.querySelector('.left-sidebar').focus();
                });
            }
        }

        let closeMenu = document.querySelectorAll(".close-menu-icon");
        for(let i = 0; i < closeMenu.length;i++) {
            if(closeMenu[i]){
                closeMenu[i].addEventListener('click', function(){
                    document.querySelector('.left-sidebar').classList.remove('open-sidebar');
                });
            }

        }

        // Scrolling
        window.onscroll = function() {
            let stickyElement = document.getElementById('sticky');
            if(stickyElement) {
                if(window.scrollY > 50 ) {
                    stickyElement.classList.add('sticky');
                } else {
                    stickyElement.classList.remove('sticky');
                }
            }
        };


        // autosize textarea

        const tx = document.getElementsByTagName('textarea');
        for (let i = 0; i < tx.length; i++) {
            tx[i].setAttribute('style', 'height:' + (tx[i].scrollHeight) + 'px;overflow-y:hidden;');
            tx[i].addEventListener("input", OnInput, false);
        }

        function OnInput() {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
        }
    },
}

// element.classList.add();
</script>

<style scoped>
    .maxh-chat {
        max-height: 100vh;
    }
</style>
